<script setup lang="ts">
import { useToast } from "../composables/useToast";
import BaseToast from "./BaseToast.vue";

const { toasts, hideToast } = useToast();
</script>

<template>
  <div class="toast-container">
    <TransitionGroup
      name="slide-up"
      enter-active-class="slide-up-enter-active"
      leave-active-class="slide-up-leave-active"
      enter-from-class="slide-up-enter-from"
      leave-to-class="slide-up-leave-to"
    >
      <BaseToast
        v-for="toast in toasts"
        :key="toast.id"
        :message="toast.message"
        :type="toast.type"
        @close="() => hideToast(toast.id)"
      />
    </TransitionGroup>
  </div>
</template>

<style lang="scss" scoped>
.toast-container {
  display: flex;
  position: fixed;
  z-index: 9999;
  bottom: 1rem;
  flex-direction: column;
  width: 100%;
  pointer-events: none;
  gap: 0.75rem;
}

.slide-up-enter-active {
  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.slide-up-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-up-enter-from {
  transform: translateX(-50%) translateY(100%) scale(0.9);
  opacity: 0;
}

.slide-up-leave-to {
  transform: translateX(-50%) translateY(20px) scale(0.95);
  opacity: 0;
}
</style>
